import React from 'react';
import '../../css/ProductImagesCarousel.css'

const ProductImageCarousel = ({ images }) => {
    if (!images || images.length === 0) return null;

    return (
        <div id="productCarousel" className="carousel slide" data-ride="carousel">
            {/* Indicators */}
            <ol className="carousel-indicators">
                {images.map((_, index) => (
                    <li
                        key={index}
                        data-target="#productCarousel"
                        data-slide-to={index}
                        className={index === 0 ? 'active' : ''}
                    ></li>
                ))}
            </ol>

            {/* Slides */}
            <div className="carousel-inner" role="listbox">
                {images.map((img, index) => (
                    <div
                        className={`item ${index === 0 ? 'active' : ''}`}
                        key={index}
                    >
                        <img
                            src={`${process.env.REACT_APP_ADMIN_BACKEND_URL}/uploads/products/${img.preview}`}
                            alt={`Product ${index}`}
                            className="img-responsive center-block"
                        />
                    </div>
                ))}
            </div>

            {/* Controls */}
            {images.length > 1 && (
                <>
                    <a
                        className="left carousel-control"
                        href="#productCarousel"
                        role="button"
                        data-slide="prev"
                    >
                        <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                        <span className="sr-only">Previous</span>
                    </a>
                    <a
                        className="right carousel-control"
                        href="#productCarousel"
                        role="button"
                        data-slide="next"
                    >
                        <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                        <span className="sr-only">Next</span>
                    </a>
                </>
            )}
        </div>
    );
};

export default ProductImageCarousel;
